import * as React from 'react';
import { Body1 } from '@cian/ui-kit';
import cn from 'clsx';

import * as styles from './styles.css';

export interface IAgreementProps {
  multiLine?: boolean;
}
export const Agreement: React.FC<React.PropsWithChildren<IAgreementProps>> = props => {
  const { children, multiLine } = props;

  return (
    <div data-testid="agreement" className={cn(styles['container'], { [styles['multiline']]: multiLine })}>
      <Body1 display="inline">{children}</Body1>
    </div>
  );
};

Agreement.displayName = 'Agreement';
